import React, { useMemo } from "react";
import { Box, Typography, Button } from "@mui/material";
import {
  headerContainerSx,
  innerHeaderSx,
  logoNameContainerSx,
  logoSx,
  separatorSx,
  nameTextSx,
  rightClusterSx,
  userBlockSx,
  userNameSx,
  logoutButtonSx,
  envLabelSx,
} from "./HeaderStyles";
import logoImage from "../assets/cgi_logo.svg";
import useAuthUser from "../features/auth/hooks/useAuthUser";
import { logout as doLogout } from "../features/auth/utils/auth";
import OTMVersionInfo from "../features/version/components/OTMVersionInfo";

const Header = () => {
  const { loading, user } = useAuthUser();

  const displayName = useMemo(() => {
    const raw = (user?.name || "").trim();
    if (!raw) return "";
    const comma = raw.indexOf(",");
    if (comma !== -1) {
      const last = raw.slice(0, comma).trim();
      const first = raw.slice(comma + 1).trim();
      return first && last ? `${first} ${last}` : (first || last);
    }
    return raw;
  }, [user?.name]);

  // Determine environment label from base URL only
  const envLabel = useMemo(() => {
    const { origin, pathname } = window.location;
    // Only check up to the first '/'
    const baseUrl = `${origin}${pathname.split('/')[1] ? '/' + pathname.split('/')[1] : ''}`.toLowerCase();
    if (baseUrl.includes("dev")) return "dev";
    if (baseUrl.includes("preprod")) return "preprod";
    return null;
  }, []);

  return (
    <Box sx={headerContainerSx}>
      <Box sx={innerHeaderSx}>
        <Box sx={logoNameContainerSx}>
          <Box component="img" src={logoImage} alt="CGI Logo" sx={logoSx} />
          <Box sx={separatorSx} aria-hidden />
          <Typography sx={nameTextSx}>
            On Train Metering
            {envLabel && (
              <span style={envLabelSx}>
                {envLabel === 'dev' ? 'DEV' : 'PREPROD'}
              </span>
            )}
          </Typography>
        </Box>

        <Box sx={rightClusterSx}>
          <OTMVersionInfo />
          {!loading && user && (
            <>
              <Box sx={separatorSx} aria-hidden />
              <Box sx={userBlockSx}>
                <Typography variant="subtitle1" sx={userNameSx}>
                  {displayName}
                </Typography>
              </Box>

              <Box sx={separatorSx} aria-hidden />

              <Button
                onClick={doLogout}
                sx={logoutButtonSx}
                aria-label="Sign out"
                type="button"
              >
                Sign out
              </Button>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
